<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <user-excuse-type-create-or-update v-model="userExcuseType"></user-excuse-type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { UserExcuseApi } from '@/api/user-excuse'
import UserExcuseTypeCreateOrUpdate from './components/UserExcuseTypeCreateOrUpdate.vue'
export default {
    components:{
        BCard,
        UserExcuseTypeCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'İzin Türü',key:'Name',sortable:true, thClass:'w-100'},
                
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            userExcuseType:{
                Id:null,
                Name: null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.userExcuseType.Id = null
            this.userExcuseType.Name = null
        },
        provider(data){
            return UserExcuseApi.Type.Table(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.userExcuseType.Id = item.Id
            this.userExcuseType.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            UserExcuseApi.Type.CreateOrUpdate(this.editing,this.userExcuseType).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} adlı izin türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    UserExcuseApi.Type.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>